<section class="panel widget-container navigator-panel" [class.mojo-admin-page]="isMojoDashboard">
  <a [routerLink]="route">
    <header class="panel-heading">
      <h5 class="panel-title">{{panelTitle}}</h5>
    </header>
    <div class="grid navigator-panel-body">

      <div class="col navigator-panel-text">
        {{panelText}}
      </div>
      <div class="col navigator-panel-icon">
        <ng-content select="[panel-icon-content]"></ng-content>
      </div>
    </div>
  </a>
</section>
